import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { SurveyService } from './service/survey.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import { LoginService } from '../../../components/login/service/login.service';
@Component({
  selector: 'app-survey-records',
  templateUrl: './survey-records.component.html',
  styleUrl: './survey-records.component.scss'
})
export class SurveyRecordsComponent {
  showData = 'survey';
  public tableSearch!: string;
  tableSearchUpdate = new Subject<string>();
  surveyResult: any = [];
  surveyTableData: any = [];
  ivyResult: any = [];
  ivyTableData: any = [];
  questionAnswersData: any = [];
  sentimentData: any = [];
  comments!: string;
  surveyPayload: any = {};
  spinner: boolean = false;
  searchText = '';
  usersRole!: number;
  userDetails: any;
  page = 1;
  limit = 25;
  myOptions:any = {
    placement: 'top',
    showDelay: 200,
    hideDelay: 0,
    maxWidth: 200,
    zIndex: 100000,
    trigger: 'hover',
    shadow: true,
  };
  tableTrVar!: number;
  audioFileIndex = -1;
  audioSpinner = false;
  audioSafeUrl!: SafeUrl;
  showPlayPause: boolean = false;
  showModalAudioTag: boolean = false;
  audio: any;
  fileIndex!: number;
  myBlob = new Blob();
  blobFile!: File;
  blobUrl: any;


  constructor(
    private surveyService: SurveyService,
    private service:LoginService,
    private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
   let user = localStorage.getItem("user");
                   if(user){
                     var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
                     this.userDetails = JSON.parse(data);
                   }   
    this.usersRole = this.userDetails?.role;
    this.surveyPayload = {
      page: this.page,
      limit: this.limit,
    };
    this.getSurveyListData();
  }

  openDoc(data: string) {
    this.ivyTableData = [];
    this.surveyResult = [];
    this.surveyTableData = [];
    this.showData = data;
    this.tableSearch = '';
    this.page = 1;
  }

  pageChanged(event: any) {
    this.page = event;
    if (this.showData === 'survey') {
      this.surveyPayload = {
        page: this.page,
        limit: this.limit,
      };
      this.getSurveyListData();
    }
    if (this.showData === 'ivy') {
      this.getIvyListData();
    }
  }

  getIvyListData() {
    this.spinner = true;
    this.surveyService.ivyListData().subscribe({
      next: (res:any) => {
        this.ivyResult = res;
        this.ivyTableData = this.ivyResult.result;
        this.spinner = false;
      },
      error: (error:HttpErrorResponse) => {
        console.log('survey list api error', error.error['message']);
        this.spinner = false;
      },
    });
  }

  getSurveyListData() {
    this.spinner = true;
    this.surveyService.surveyListData(this.surveyPayload).subscribe({
      next: (res:any) => {
        this.surveyResult = res;
        this.surveyTableData = this.surveyResult.result;
        this.spinner = false;
      },
      error: (error:HttpErrorResponse) => {
        console.log('survey list api error', error.error['message']);
        this.spinner = false;
      },
    });
  }

  tableBack(index: number) {
    this.tableTrVar = index;
  }

  clearQuestionAnswersData() {}

  sendIndex(index: any) {
    this.questionAnswersData = [];
    if (this.showData === 'survey') {
      this.questionAnswersData = this.surveyTableData[index]?.question_answers;
      this.sentimentData = this.surveyTableData[index]?.comments_sentiment;
      this.comments = this.surveyTableData[index]?.comments;
    }
    if (this.showData === 'ivy') {
      this.fileIndex = index;
      console.log('fileindex', this.fileIndex);
      
      this.questionAnswersData = this.ivyTableData[index]?.filter(
        (data: any) => {
          return data.sequence !== '3';
        }
      );
      const sentimentData = this.ivyTableData[index]?.filter((data: any) => {
        return data.sequence === '3';
      });
      this.sentimentData = sentimentData[0];
      const comments = this.ivyTableData[index]?.filter((data: any) => {
        return data.sequence === '3';
      });
      this.comments = comments[0]?.transcribe_text;
    }
  }

  playAudioFile(index: any) {
    this.audioSafeUrl = '';
    this.audioFileIndex = index;
    console.log("audo file index", this.audioFileIndex);
    this.audioSpinner = true;
    this.showPlayPause = false;
    const fileName = this.ivyTableData[index][3].filename;
    console.log("filename", fileName);
    this.surveyService.getAudioFile(fileName).subscribe({
      next: async (response:any) => {
        this.myBlob = new Blob([response as Blob]);
        this.blobFile = new File([this.myBlob], 'myaudio.mp3', {
          type: 'audio/mp3',
        });
        this.blobUrl = URL.createObjectURL(this.blobFile);
        this.audioSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.blobUrl
        );
        this.audioSpinner = false;
        this.showModalAudioTag = true;
      },
      error: (error:HttpErrorResponse) => {
        this.audioSpinner = false;
      },
    });
  }

  audioTagChange(event: any) {
    if (event === 'play') {
      this.showPlayPause = true;
    } else if (event === 'pause') {
      this.showPlayPause = false;
    }
  }

  playAD(value: string) {
    this.audio = document.getElementById('audioTagAnalysis');
    this.showPlayPause = !this.showPlayPause;
    if (value === 'pause') {
      this.audio.pause();
    } else if (value === 'play') {
      this.audio.play();
    }
  }

  closeAudioTag() {
    this.audioFileIndex = -1;
    this.showModalAudioTag = false;
  }
}
